import React from 'react'
import './index.scss'
//api
import { api } from '../../../functions/api'
//material ui
import { Grid, Paper } from '@material-ui/core'
//custom components
import CustomInput from '../../../components/basic/input'
// import CustomButton from '../../../components/basic/CustomButton';
import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch'
//other libraries
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
// import Icon from '@mdi/react'
// import { mdiContentSaveOutline } from '@mdi/js'

const TIMEOUT = 500

@inject('internal')
@inject('translate')
@observer
export default class ContactInfo extends React.Component {
  
  timeout = null
  
  constructor(props) {
    super(props)
    
    this.state = {
      emails: [],
      service_protocols_emails: [],
    }
  }
  
  componentWillUnmount() {
    clearTimeout(this.timeout)
  }
  
  componentDidMount() {
    const hue = toJS(this.props.internal.dataForSimpeTable.customer_orders_emails || []).map(item => item.trim())
    const hue2 = toJS(this.props.internal.dataForSimpeTable.service_protocols_emails || []).map(item => item.trim())
    const hue3 = toJS(this.props.internal.dataForSimpeTable.contract_withdrawal_emails || []).map(item => item.trim())
    
    this.setState({
      emails: hue.map(value => ({ value, label: value })),
      service_protocols_emails: hue2.map(value => ({ value, label: value })),
      contract_withdrawal_emails: hue3.map(value => ({ value, label: value })),
    })
  }
  
  handleChange = () => {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.updateData()
    }, TIMEOUT)
  }
  
  validateEmails(emails) {
    return emails.filter(email => /\S+@\S+\.\S+/.test(email.value))
  }
  
  handleSelectChange = (field,value) => {
    this.setState({ [field]: this.validateEmails(value) })
    
    this.handleChange()
  }
  
  updateData = async () => {
    let email_primary = this.email_primary.state.value
    let email_secondary = this.email_secondary.state.value
    let fax = this.fax.state.value
    let phone_primary = this.phone_primary.state.value
    let phone_secondary = this.phone_secondary.state.value
    let iban = this.iban.state.value
    let customer_orders_emails = this.state.emails.map(item => item.value)
    let service_protocols_emails = this.state.service_protocols_emails.map(item => item.value)
    let contract_withdrawal_emails = this.state.contract_withdrawal_emails.map(item => item.value)
    
    let update_global_settings = await api({
      method: 'post',
      url: 'global-settings',
      authorization: this.props.internal.user.access_token,
      params: {
        email_primary: email_primary,
        email_secondary: email_secondary,
        fax: fax,
        phone_primary: phone_primary,
        phone_secondary: phone_secondary,
        customer_orders_emails: customer_orders_emails,
        service_protocols_emails: service_protocols_emails,
        contract_withdrawal_emails: contract_withdrawal_emails,
        iban
        
        //vyplname v predchadzajucom tabe
        // project_name: toJS(this.props.internal.dataForSimpeTable.project_name),
        // seo_title: toJS(this.props.internal.dataForSimpeTable.seo_title),
        // client_name: toJS(this.props.internal.dataForSimpeTable.client_name),
        // address: {
        //     street_name: toJS(this.props.internal.dataForSimpeTable.address.street_name),
        //     street_no: toJS(this.props.internal.dataForSimpeTable.address.street_no),
        //     city: toJS(this.props.internal.dataForSimpeTable.address.city),
        //     zip: toJS(this.props.internal.dataForSimpeTable.address.zip),
        //     country: toJS(this.props.internal.dataForSimpeTable.address.country),
        // },
        // id_no: toJS(this.props.internal.dataForSimpeTable.id_no),
        // id_vat: toJS(this.props.internal.dataForSimpeTable.id_vat),
        // id_tax: toJS(this.props.internal.dataForSimpeTable.id_tax),
      },
    })
    
    if (update_global_settings.success === true) {
      this.props.internal.setDataForSimpeTable(update_global_settings.data.data)
      this.props.internal.setSnackbar(update_global_settings.data.message, true)
    } else {
      let resultError = ''
      if (update_global_settings.data.data.errors) {
        for (let error in update_global_settings.data.data.errors) {
          if (/^customer_orders_emails/.test(error)) {
            setTimeout(() => {
              const { emails } = this.state
              emails.pop()
              this.setState({ emails })
            }, 500)
          }
          resultError += update_global_settings.data.data.errors[error] + ' '
        }
      }
      this.props.internal.setSnackbar(resultError, true)
    }
  }
  
  render() {
    return (
      <Paper className={'settings-basic'}>
        <Grid container spacing={16}>
          {/* <Grid item xs={12} className={'save-btn'}>
                        <CustomButton
                            // progressBar={this.state.loading}
                            onClick={this.updateData}
                            mystyle={'btn-orange-bg border-radius-18'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        >
                            <Icon path={mdiContentSaveOutline} size={1}  />
                        </CustomButton>
                    </Grid> */}
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <CustomInput
              ref={ref => this.email_primary = ref}
              text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL_PRIMARY}
              value={toJS(this.props.internal.dataForSimpeTable.email_primary)}
              id={'email_primary'}
              className={'w-100'}
              change={this.handleChange}
            />
          </Grid>
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <CustomInput
              ref={ref => this.email_secondary = ref}
              text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL_SECONDARY}
              value={toJS(this.props.internal.dataForSimpeTable.email_secondary)}
              id={'email_secondary'}
              className={'w-100'}
              change={this.handleChange}
            />
          </Grid>
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <CustomInput
              ref={ref => this.phone_primary = ref}
              text={this.props.translate.i18n.GLOBAL.CONTACT.PHONE_PRIMARY}
              value={toJS(this.props.internal.dataForSimpeTable.phone_primary)}
              id={'phone_primary'}
              className={'w-100'}
              change={this.handleChange}
            />
          </Grid>
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <CustomInput
              ref={ref => this.phone_secondary = ref}
              text={this.props.translate.i18n.GLOBAL.CONTACT.PHONE_SECONDARY}
              value={toJS(this.props.internal.dataForSimpeTable.phone_secondary)}
              id={'phone_secondary'}
              className={'w-100'}
              change={this.handleChange}
            />
          </Grid>
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <CustomInput
              ref={ref => this.fax = ref}
              text={this.props.translate.i18n.GLOBAL.CONTACT.FAX}
              value={toJS(this.props.internal.dataForSimpeTable.fax)}
              id={'fax'}
              className={'w-100'}
              change={this.handleChange}
            />
          </Grid>
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <CustomInput
              ref={ref => this.iban = ref}
              text={this.props.translate.i18n.GLOBAL.CONTACT.IBAN}
              value={toJS(this.props.internal.dataForSimpeTable.iban)}
              id={'iban'}
              className={'w-100'}
              change={this.handleChange}
            />
          </Grid>
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <SelectSearch
              isMulti
              isCreatable
              onChange={value => this.handleSelectChange('emails', value)}
              options={this.state.emails}
              value={this.state.emails}
              label={this.props.translate.i18n.GLOBAL.CONTACT.CUSTOMER_ORDERS_EMAILS}
            />
          </Grid>
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <SelectSearch
              isMulti
              isCreatable
              onChange={value => this.handleSelectChange('service_protocols_emails', value)}
              options={this.state.service_protocols_emails}
              value={this.state.service_protocols_emails}
              label={this.props.translate.i18n.GLOBAL.CONTACT.SERVICE_PROTOCOLS_EMAILS}
            />
          </Grid>
          <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
            <SelectSearch
              isMulti
              isCreatable
              onChange={value => this.handleSelectChange('contract_withdrawal_emails', value)}
              options={this.state.contract_withdrawal_emails}
              value={this.state.contract_withdrawal_emails}
              label={this.props.translate.i18n.GLOBAL.CONTACT.CONTRACT_WITHDRAWAL_EMAILS}
            />
          </Grid>
        </Grid>
      
      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/settings/contact/index.js